import {ssrLazy} from 'ssr/lazy';

export const SuperheroCarouselLazy = ssrLazy(() => import(/* webpackChunkName: "superheroCarousel" */ '../initSuperhero'));
